import { render, staticRenderFns } from "./NotificationReporter.vue?vue&type=template&id=c7894ae0&"
import script from "./NotificationReporter.vue?vue&type=script&lang=js&"
export * from "./NotificationReporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports